<template>
  <div class="content al_c">

<template v-if="!change_pw_mode">
	<s-location notice title="로그인"/>
<!--     <s-location title="로그인" hide-subtitle /> -->

    <div class="login_wrap">
      <h3> <p>변호사 출입관리 시스템</p> </h3>

      <input v-model="login.id" ref="id" type="text" title="아이디 입력" 	placeholder="아이디 입력" name="kwd"   id="topKwd" class="tplaceholder" :rules="[rules.alphabet, rules.min]" />
      <input v-model="login.pw"          type="password" title="비밀번호 입력" placeholder="비밀번호 입력" name="kwd" id="topKwd" class="tplaceholder" @keydown.enter="doLogin" :rules="[rules.min]" />
      <label  class="checkbox"><input type="checkbox" name="saveId" value="1">아이디저장</label>
      <div class="btn xl blue01" @click="doLogin">로그인</div>
      <!-- <div class="info_user"> -->
        <!-- <router-link to="/member/join" class="left">회원가입</router-link> -->
        <!-- <a href="" class="right">아이디/비밀번호 찾기</a> -->
      <!-- </div> -->
    </div>
</template>
<template v-else>
    <s-location mypage title="비밀번호 변경"/>

    <div class="cont_w800 comment dot_gray bg_gray  expcomment">
      <p class="tit"> 안내</p>
      <li>{{ msg }}</li>
    </div>

    <div class="al_c">
      <table class="tbl01 cont_w800 " >
        <tr>
          <th width="200px"> 새 비밀번호 </th>
          <td style="text-align:left;">
            <input width="200" ref="pw_new" v-model="item.pw_new"          type="password" title="새 비밀번호 입력" placeholder="새 비밀번호 입력" @keydown.enter="doChange" maxlength="16"/>
            <div class="input-error" v-if="inputError.pw_new">{{ inputError.pw_new }}</div>
          </td>
        </tr>
        <tr>
          <th> 새 비밀번호 확인 </th>
          <td style="text-align:left;">
            <input v-model="item.pw_newchk"       type="password" title="새 비밀번호 확인" placeholder="새 비밀번호 확인" @keydown.enter="doChange" maxlength="16"/>
            <div class="input-error" v-if="inputError.pw_newchk">{{ inputError.pw_newchk }}</div>
          </td>
        </tr>
      </table>
    </div>
    <div class="btn_group btn blue01" style="max-width:200px;" @click="doChange">비밀번호 변경</div>
</template>
</div>
</template>
<script>
let ui
export default {
  created() {
    ui = this.$ui;
  },
  mounted() {
    // this.$refs.id.$el.getElementsByTagName("input")[0].focus()

    // 단말기 번호 부여
    ui.httpGet('/auth/get_device_no', {},
      ret => {
        const {status, dno} = ret.data
        if (status == "OK" && dno) {
          if (!this.$cookie.get('dno')) { // 보통 자동으로 되지만.. 안된다면 vue에서 직접 쿠키셋팅
            console.log("단말기 번호를 직접 설정합니다. dno =", dno);
            this.$cookie.set('dno', dno, 365);
          }
        }
      })

    this.$refs.id.focus()
  },
  data() {
    return {
      err_msg: '',
      login: {
        id: '',
        pw: '',
      },
      item: {
        pw_new: '',
        pw_newchk: '',
      },
      inputError: {pw : '',  pw_new : '', pw_newchk : ''},
      rules: {
        alphabet : v=> /[a-zA-Z]+/.test(v) || '영문을 포함하여 입력하세요.',
        min: v => v.length >= 3 || '3자 이상 입력하세요.',
      },
      x: [],
      test_login :1,
      change_pw_mode : false,
      msg : '바꾸자'
    }
  },
  watch: {
    err_msg() { // sso 오류메세지 출력
      this.err_msg && ui.alert_error(this.err_msg)
    },
    "item.pw_new"(v) { this.inputError.pw_new = this.checkInput('pw_new', v) },
    "item.pw_newchk"(v) { this.inputError.pw_newchk = this.checkInput('pw_newchk', v) },
  },
  beforeRouteEnter (to, from, next) {

    if (to && to.query && to.query.mode == 'sso') {

      console.log("to.query = ", to.query);

      // mode: "sso"
      // sso_no: "5"
      // sso_key: "5vjzamz2mcv9tur6blhpocpww9hvyx4rk290hjub5tw4ub96k4"
      T.httpGet("/auth/sso_recv", to.query,
        ret=>{
          console.log(ret.data)
          if (ret.data) {
            const {status, msg, token, message} = ret.data
            if (status == 'OK') {
              next(vm => {
                vm.$store.commit("session/SET_TOKEN", token) // 로그인 완료 처리
                vm.$router.replace('/main/main')
              })
            } else {
              const err_msg = msg || message // SSO 오류는 msg 에 프로시져 자체 오류는 message 로 넘어온다..
              next(vm => vm['err_msg'] = err_msg) // 오류를 반환했을때
            }
          }
        }, null, v=>next()) // 어떤 경우라도 화면은 나와야 하니깐..

    } else if (to && to.query && to.query.mode == 'login_switch') {

      console.log("to.query = ", to.query);

      // mode: "login_switch"
      // id: "seoulbar03"
      T.httpGet("/auth/login_switch", to.query,
        ret=>{
          console.log(ret.data)
          if (ret.data) {
            const {status, msg, token, message} = ret.data
            if (status == 'OK') {
              next(vm => {
                vm.$store.commit("session/SET_TOKEN", token) // 로그인 완료 처리
                vm.$router.replace('/') // 메인으로 이동
              })
            } else {
              const err_msg = msg || message // SSO 오류는 msg 에 프로시져 자체 오류는 message 로 넘어온다..
              next(vm => vm['err_msg'] = err_msg) // 오류를 반환했을때
            }
          }
        }, null, v=>next()) // 어떤 경우라도 화면은 나와야 하니깐..

    } else {
      return next()
    }

  // beforeRouteEnter(to, from, next) {
  //     next(vm => {
  //       if(from.path === '/somePath'  && vm.someData.length > 0) {
  //         vm.$router.push({ name: 'some_name'})
  //       } else {
  //         vm.$router.push({ name: 'another_name'})
  //       }
  //     })
  //   },

    // https://router.vuejs.org/kr/guide/advanced/data-fetching.html#%ED%83%90%EC%83%89-%ED%9B%84-%EA%B0%80%EC%A0%B8%EC%98%A4%EA%B8%B0

    // getPost(to.params.id, (err, post) => {
    //   next(vm => vm.setData(err, post))
    // })
    // next()
  },
  methods: {
    mlogin(id, pw) {
      this.login.id = id
      this.login.pw = pw
      this.doLogin()
    },
    doLogin() {

      ui.httpPost('/auth/login', this.login,
        ret => {
          // const {tot_rows, tot_pages, pgsize, page} = ret.data.rs1[0]
          console.log("ret.data", ret.data);
          if (!ret.data)
            return

          // const {status, token, user, msg} = ret.data;
          const {status, token, msg} = ret.data;
          if (status == "OK") {
            console.log("로그인 폼에서 로그인 완료 처리");
            this.$store.commit("session/SET_TOKEN", token);
            this.$router.push(this.$route.query.redirect || '/')
            return
          } else if (status == "NEED_CHANGE_PW") {
            this.change_pw_mode = true // 비밀번호 변경모드로 전환
            this.msg = msg
            ui.alert(msg, "비밀번호 변경 필요", {color: 'red', width: 518})
            .then(()=>this.$refs.pw_new.focus())
            return
          } else {
            // const cmt = T.contains(msg, '가입승인') ? msg : `등록된 아이디가 아니거나 비밀번호가 일치하지 않습니다.`
            ui.alert_error(msg, "로그인 실패", {color: 'red', width: 518})
          }

        }, null, v=>this.loading = false)

    },
    checkInput(kind, v) {
      if (_.isEmpty(v)) return ""

      switch(kind) {
        case "pw_new":
          if (!/^[\da-zA-Z$@$!%*?&\\.]{8,16}$/.test(v)) return "8~16자 영문 대 소문자, 숫자 2자 이상, 특수문자 1자 이상을 입력해 주세요"
          if (!/\d/.test(v)) return "숫자 1자 이상을 입력해 주세요"
          if (!/[$@$!%*?&\\.]/.test(v)) return "특수문자 1자 이상을 입력해 주세요"
          return ""
        case "pw_newchk":
          // console.log(this.item.pw_new);
          // console.log(v);
          if (this.item.pw_new != v) return "비밀번호와 비밀번호 확인이 일치하지 않습니다."
          return ""
      }
    },

    doChange() {

      if (this.inputError.pw_new.length != 0 || this.inputError.pw_newchk.length != 0 || !this.item.pw_new || !this.item.pw_newchk){
        ui.alert("비밀번호 형식에 맞게 입력해주세요.")
        return
      }

      // 비밀번호 업데이트
      ui.httpPost('/auth/login',
      {
        pw_channge_mode: 1,
        id : this.login.id,
        pw : this.login.pw,
        pw_new : this.item.pw_new
      },
      ret => {
        const { msg, token, status } = ret.data

        console.log("mag : " + msg);
        console.log("status : " + status);

        if (status == 'OK'){
          this.$store.commit("session/SET_TOKEN", token);
          ui.alert("비밀번호가 성공적으로 변경되었습니다.")
            .then(()=>this.$router.push(this.$route.query.redirect || '/'))
          return;

        } else {
          ui.alert_error(msg)
        }

        this.item = { pw_new : '', pw_newchk : ''}

      })

    }


  },
}
</script>
<style scoped>

  /*-----------------------------------------------------------------------------------------------
    LOGIN :: 로그인
  -------------------------------------------------------------------------------------------------*/
  .login_wrap { display: inline-block; width: 100%; max-width: 480px; margin: 50px auto 20px auto; position:relative; padding: 35px 45px; border: 1px solid #e5e5e5; font-size: 16px; vertical-align: top; box-sizing: border-box; text-align: left; }
  .login_wrap h3 { font-size : 18px;  margin-bottom:40px;}
  .login_wrap h3 p{ color:#064680; margin-top:10px; font-size: 22px;}
  .login_wrap input[type="text"], .login_wrap input[type="password"]{ width: 100%; height: 48px; padding: 11px 70px 11px 11px; font-size:16px; font-weight:700; box-sizing: border-box; background-color: #f3f3f3; margin-bottom:10px; }
  .login_wrap .btn { margin:40px 0 5px 0;}
  .info_user { font-size:13px;}

  .sel_mem li { width:30%; padding: 15px; font-size:14px;}
  .sel_mem li .tit{font-size:15px;}

  .sel_mem li .cont { font-size:14px; font-weight: normal}

  .input-error { color: red; margin-top: 7px;  }

</style>